import React from 'react'
import { useNavigate } from 'react-router-dom'

import { BaseView, BaseText } from '@/components/base'
import { AppIcons } from '@/components/AppIcons'
import { useTheme } from '@/hooks/useTheme'

interface NotificationsProps {
  notificationsQtd?: number
}

export const Notifications: React.FC<NotificationsProps> = ({
  notificationsQtd = 0,
}) => {
  const navigate = useNavigate()
  const theme = useTheme()

  const hasNotifications = notificationsQtd > 0

  const handlePress = () => {
    navigate('/notifications')
  }

  return (
    <BaseView
      data-component="notifications-header"
      style={{
        position: 'relative',
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '8px',
        paddingRight: '0',
      }}
      onClick={handlePress}
    >
      {/* Bell Icon - точно как в React Native */}
      <AppIcons name="bell" color="icon.iconCard" size={32} />

      {/* Notification Badge */}
      {hasNotifications && (
        <BaseView
          circle
          circleSize={18}
          center
          style={{
            position: 'absolute',
            right: '-3px',
            top: '-3px',
            backgroundColor: theme.colors.background.buttonPrimaryEnabled,
            borderColor: theme.colors.background.screen,
            borderWidth: '1px',
            borderStyle: 'solid',
          }}
        >
          <BaseText
            fontSize={10}
            fontFamily="semibold"
            color="label.buttonPrimaryEnabled"
          >
            {notificationsQtd}
          </BaseText>
        </BaseView>
      )}
    </BaseView>
  )
}
